import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { PageService } from './page.service';
import { SidenavData } from '../models/sidenav-data';

@Injectable({
  providedIn: 'root'
})
export class ToolbarOptionsService extends PageService<SidenavData> {

  constructor(http: HttpClient) {
    super(http);
  }
}
